export const GET_ALTERNATIVE_CAMPAIGN = '/api/alternativecampaigns/get'
export const ALL_ALTERNATIVE_CAMPAIGNS = '/api/alternativecampaigns/active'
export const CREATE_ALTERNATIVE_CAMPAIGN = '/api/alternativecampaigns/create'
export const GET_NAMES_ALTERNATIVE_CAMPAIGN = '/api/alternativecampaigns/availablenames'
export const CLOSE_ALTERNATIVE_CAMPAIGN = '/api/alternativecampaigns/close'
export const UNASSIGNED_ALTERNATIVE_CAMPAIGN = '/api/alternativecampaigns/unassigned'
export const SEND_EMAILS_ALTERNATIVE_CAMPAIGN = '/api/alternativecampaigns/sendemails'
export const CODE_RESET_ALTERNATIVE_CAMPAIGN = '/api/alternativecodes/reset'
export const CODE_DELETE_ALTERNATIVE_CAMPAIGN = '/api/alternativecodes/delete'
export const RESET_MANY_ALTERNATIVE_CAMPAIGN = '/api/alternativecodes/resetmany'
export const DELETE_MANY_ALTERNATIVE_CAMPAIGN = '/api/alternativecodes/deletemany'
export const ALTERNATIVE_HISTORY_EMAILS = '/api/alternativeemails/all'
export const ALTERNATIVE_INDIVIDUAL_LISTS = '/api/alternativeemails/IndividualLists'
export const GET_CURRENT_EMAIL_TEMPLATE = '/api/alternativeemailtemplate/current'
export const UPDATE_CURRENT_EMAIL_TEMPLATE = '/api/alternativeemailtemplate/update'
export const CAMPAIGN_ADD_EMAIL = '/api/alternativecampaigns/addtocampaign'



// WEBPACK FOOTER //
// ./src/api/extra-campaigns/types.js